// extracted by mini-css-extract-plugin
export default {"spinner":"Y6Pitg","isUploading":"NULWwv","rotate":"r91epm","dash":"s0OFkj"};